module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Nurse Payment Requests",
      "name": "first"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentFilter", $$v)
      },
      expression: "filters.paymentFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest()
      }
    },
    model: {
      value: (_vm.filters.paymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "paymentStatus", $$v)
      },
      expression: "filters.paymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportPaymentRequest', 'Active Offer.xls')
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showAdjust()
      }
    }
  }, [_vm._v("Adjust Balance")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstListLoading),
      expression: "firstListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.payments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseNote",
      "label": "Nurse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.nurseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nurseName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.requestPayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.editPaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                                Reject\n                            ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Pending Transactions",
      "name": "second"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Offer",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.pendingFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingFilter", $$v)
      },
      expression: "filters.pendingFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPendingTransaction
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getPendingTransaction
    },
    model: {
      value: (_vm.filters.pendingUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pendingUser", $$v)
      },
      expression: "filters.pendingUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.secondListLoading),
      expression: "secondListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.pendingPayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "offerNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Offer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "takeDate",
      "label": "Offer Create Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.pendingTotal
    },
    on: {
      "current-change": _vm.changePendingRequest
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Transaction",
      "name": "third"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getTransactionHistory
    },
    model: {
      value: (_vm.filters.currentUser),
      callback: function($$v) {
        _vm.$set(_vm.filters, "currentUser", $$v)
      },
      expression: "filters.currentUser"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search Product Name, Note, Account etc.",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.historyFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "historyFilter", $$v)
      },
      expression: "filters.historyFilter"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getTransactionHistory
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportTransactionHistory
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thirdListLoading),
      expression: "thirdListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.transactions,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dateTime",
      "label": "Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Transaction"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 'transaction') ? _c('div', [_c('p', [_vm._v("For " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'reported') ? _c('div', [_c('p', [_vm._v("Reported for " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime))]), _vm._v(" "), _c('p', {
          staticClass: "note"
        }, [_vm._v("$" + _vm._s(scope.row.price) + " * " + _vm._s(scope.row.quantity) + ".\n                                    " + _vm._s(scope.row.warehouse))])]) : _vm._e(), _vm._v(" "), (scope.row.type == 'adjust') ? _c('div', [(scope.row.amount > 0) ? _c('p', [_vm._v("Increase Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), (scope.row.amount <= 0) ? _c('p', [_vm._v("Decrease Balance, " + _vm._s(scope.row.dateTime))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.type == 'payment') ? _c('div', [_c('p', [_vm._v("Withdraw to " + _vm._s(scope.row.productName) + ", " + _vm._s(scope.row.dateTime) + "\n                                    "), (scope.row.status === 0) ? _c('span', [_vm._v("(waiting for pay)")]) : (scope.row.status === 1) ? _c('span', [_vm._v("(paid)")]) : (scope.row.status === 2) ? _c('span', [_vm._v("(canceled)")]) : (scope.row.status === 3) ? _c('span', [_vm._v("(rollover)")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "note",
          domProps: {
            "innerHTML": _vm._s(scope.row.note)
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.amount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.amount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Balance",
      "prop": "balance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Nurse",
      "prop": "nurseName"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.historyTotal
    },
    on: {
      "current-change": _vm.changeTransactionHistory
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Balance",
      "name": "fourth"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.getBalance
    },
    model: {
      value: (_vm.filters.balanceFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "balanceFilter", $$v)
      },
      expression: "filters.balanceFilter"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fourthListLoading),
      expression: "fourthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.balances,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "User"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "Balance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.total >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.total, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pendingAmount",
      "label": "Pending"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pendingAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.pendingAmount, 2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requestAmount",
      "label": "Requestable"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.requestAmount >= 0) ? _c('span', {
          staticClass: "green-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))]) : _c('span', {
          staticClass: "reported-row"
        }, [_vm._v(_vm._s(_vm.formatMoney(scope.row.requestAmount, 2)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.balanceTotal
    },
    on: {
      "current-change": _vm.changeBalance
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Warehouse fee payment",
      "name": "fifth"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fifthListLoading),
      expression: "fifthListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.storageFeePayments,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": function($event) {}
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportMonth",
      "label": "Report Month"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 0 && scope.row.totalFee > 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Created")]) : (scope.row.payStatus == 0 && scope.row.totalFee <= 0) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("No need to pay")]) : (scope.row.payStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")]) : (scope.row.payStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Canceled")]) : (scope.row.payStatus == 3) ? _c('el-tag', [_vm._v("Archived")]) : (scope.row.payStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Rejected")]) : (scope.row.payStatus == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.totalFee > 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.showAddWarehousePayment(scope.row.id)
            }
          }
        }, [_vm._v("to Pay")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentSummary(scope.row.id)
            }
          }
        }, [_vm._v("\n                                Detail\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.storageFeePaymentTotal
    },
    on: {
      "current-change": _vm.changeStorageFeePayment
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Payment List",
      "width": "80%",
      "visible": _vm.paymentListVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.paymentListVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getPaymentRequest4Warehouse()
      }
    },
    model: {
      value: (_vm.filters.warehousePaymentStatus),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehousePaymentStatus", $$v)
      },
      expression: "filters.warehousePaymentStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Canceled",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Archived",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paymentLoading),
      expression: "paymentLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehousePayments,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "paymentNo",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.totalFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "Apply amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.formatMoney(scope.row.amount, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "doctorNote",
      "label": "Doctor Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.doctorNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseNote",
      "label": "Warehouse Note"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.warehouseNote)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "Request Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 0) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("Pending")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("Confirmed")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("Canceled")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 4) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Rejected")])], 1) : _vm._e(), _vm._v(" "), (scope.row.status === 5) ? _c('p', [_c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("Requested")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 0) ? [_c('el-button', {
          attrs: {
            "size": "small",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.requestWarehousePayment(scope.row.paymentNo)
            }
          }
        }, [_vm._v("Pay")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.editWarehousePaymentStatus(scope.row.paymentNo, 4)
            }
          }
        }, [_vm._v("\n                            Reject\n                        ")])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.paymentTotal
    },
    on: {
      "current-change": _vm.changePaymentRequest
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.paymentListVisible = false;
        _vm.filters.paymentStatus = '';
        _vm.getStorageFeePaymentList();
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment",
      "width": "80%",
      "visible": _vm.requestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.requestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "payment",
    attrs: {
      "model": _vm.payment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.payment.nurseName),
      callback: function($$v) {
        _vm.$set(_vm.payment, "nurseName", $$v)
      },
      expression: "payment.nurseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bank),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bank", $$v)
      },
      expression: "payment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.payment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.payment, "bankAddress", $$v)
      },
      expression: "payment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.payment.note),
      callback: function($$v) {
        _vm.$set(_vm.payment, "note", $$v)
      },
      expression: "payment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.requestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.pay.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Confirm a payment 4 warehouse",
      "width": "80%",
      "visible": _vm.warehouseRequestVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseRequestVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "warehousePayment",
    attrs: {
      "model": _vm.warehousePayment,
      "label-width": "220px",
      "rules": _vm.payRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "warehouseUserName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.warehousePayment.warehouseUserName),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseUserName", $$v)
      },
      expression: "warehousePayment.warehouseUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Amount",
      "prop": "totalFee"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.totalFee),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "totalFee", $$v)
      },
      expression: "warehousePayment.totalFee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Payable amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true,
      "min": 0
    },
    model: {
      value: (_vm.warehousePayment.amount),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "amount", $$v)
      },
      expression: "warehousePayment.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Account",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bank),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bank", $$v)
      },
      expression: "warehousePayment.bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bank Address",
      "prop": "bank"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea",
      "rows": "5"
    },
    model: {
      value: (_vm.warehousePayment.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "bankAddress", $$v)
      },
      expression: "warehousePayment.bankAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Warehouse Note",
      "prop": "warehouseNote"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticStyle: {
      "background-color": "#F5F7FA"
    },
    attrs: {
      "disabled": true,
      "options": _vm.readOlnyEditorOption,
      "type": "textarea"
    },
    model: {
      value: (_vm.warehousePayment.warehouseNote),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "warehouseNote", $$v)
      },
      expression: "warehousePayment.warehouseNote"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.warehousePayment.note),
      callback: function($$v) {
        _vm.$set(_vm.warehousePayment, "note", $$v)
      },
      expression: "warehousePayment.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseRequestVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toWarehousePay.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Adjust Balance",
      "width": "80%",
      "visible": _vm.adjustVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.adjustVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "adjust",
    attrs: {
      "model": _vm.adjust,
      "label-width": "220px",
      "rules": _vm.adjustRule
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User",
      "prop": "nurseId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "User",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getNusreBalance
    },
    model: {
      value: (_vm.adjust.nurseId),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "nurseId", $$v)
      },
      expression: "adjust.nurseId"
    }
  }, _vm._l((_vm.nurseList), function(nurse, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": nurse.username,
        "value": nurse.userNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Total Balance",
      "prop": "balance"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.adjust.balance),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "balance", $$v)
      },
      expression: "adjust.balance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Amount",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.adjust.amount),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "amount", $$v)
      },
      expression: "adjust.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": 1,
      "che": ""
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Decrease Balance")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.adjust.type),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "type", $$v)
      },
      expression: "adjust.type"
    }
  }, [_vm._v("Increase Balance")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Note",
      "prop": "note"
    }
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.adjust.note),
      callback: function($$v) {
        _vm.$set(_vm.adjust, "note", $$v)
      },
      expression: "adjust.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.adjustVisible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdjust.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Detail",
      "width": "80%",
      "visible": _vm.warehouseFeeDetailModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeDetailModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "ProductName",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.productName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "productName", $$v)
      },
      expression: "filters.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    }
  }, [_vm._v("Search")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeDetail', 'Warehouse Fee Detail.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Filter Fee Type",
      "filterable": true
    },
    on: {
      "change": function($event) {
        return _vm.getStorageFeePaymentDetail(null, 1)
      }
    },
    model: {
      value: (_vm.filters.feeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "feeType", $$v)
      },
      expression: "filters.feeType"
    }
  }, _vm._l((_vm.feeTypeList), function(fee, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fee.value,
        "value": fee.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeLoading),
      expression: "warehouseFeeLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeDetail,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "feeType",
      "label": "Fee Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.feeType == 0) ? _c('p', [_vm._v("Inbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 1) ? _c('p', [_vm._v("Outbound")]) : _vm._e(), _vm._v(" "), (scope.row.feeType == 2) ? _c('p', [_vm._v("Storage")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productSize",
      "label": "Category"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFee",
      "label": "Storage Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "baseFeeOver",
      "label": "Storage > Years Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Storage Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundRate",
      "label": "Inbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundQty",
      "label": "Inbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundRate",
      "label": "Outbound Rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundQty",
      "label": "Outbound Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceFee",
      "label": "Service Fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceType",
      "label": "Service Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceQty",
      "label": "Service Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "splitPackagesNum",
      "label": "Package Num"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "totalFee",
      "label": "Total Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.totalFee, 5)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundDate",
      "label": "Inbound Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.inboundDate)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.dateFormat(scope.row.reportDate)) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeDetailTotal,
      "current-page": _vm.warehouseFeeDetailPage
    },
    on: {
      "current-change": _vm.changeWarehouseFeeDetail,
      "update:currentPage": function($event) {
        _vm.warehouseFeeDetailPage = $event
      },
      "update:current-page": function($event) {
        _vm.warehouseFeeDetailPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeDetailModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Warehouse Fee Summary",
      "width": "80%",
      "visible": _vm.warehouseFeeSummaryModelVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.warehouseFeeSummaryModelVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "Product Name or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    model: {
      value: (_vm.filters.conditionSearch),
      callback: function($$v) {
        _vm.$set(_vm.filters, "conditionSearch", $$v)
      },
      expression: "filters.conditionSearch"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getStorageFeePaymentSummary(_vm.warehouseFeeDetailId)
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.postExportExcel('/excel/exportWarehouseFeeSummary', 'Warehouse Fee Summary.xls', 1)
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.warehouseFeeSummaryLoading),
      expression: "warehouseFeeSummaryLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.warehouseFeeSummary,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productNo",
      "label": "Product No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "inboundFee",
      "label": "Inbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.inboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "outboundFee",
      "label": "Outbound Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.outboundFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFee",
      "label": "Storage Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        $" + _vm._s(_vm.formatMoney(scope.row.storageFee, 2)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportDate",
      "label": "Report Date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getStorageFeePaymentDetail(scope.row.productNo, 1)
            }
          }
        }, [_vm._v("\n                            Detail\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.warehouseFeeSummaryTotal
    },
    on: {
      "current-change": _vm.changeWarehouseFeeSummary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.warehouseFeeSummaryModelVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8d2225c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/payments.vue
// module id = 848
// module chunks = 1